import { __ } from "i18n-for-browser";
import * as R from "ramda";
export default async function getKokeilulupa(
  data,
  booleans,
  locale,
  changeObjects
) {
  const kokeilulupaObj = R.find(
    R.propEq("anchor", "kokeilulupa.iskokeilulupa.A"),
    (changeObjects.kokeilulupa && changeObjects.kokeilulupa.length > 0) || []
  );

  // Ensisijaisesti käytetään changeobjects tietoa, koska oletetaan sen olevan tuoreempi kuin määräys (data).
  const isChecked =
    typeof kokeilulupaObj?.properties?.isChecked === "boolean"
      ? kokeilulupaObj.properties.isChecked
      : typeof data === "boolean"
        ? data
        : false;
  return {
    structure: [
      {
        anchor: "iskokeilulupa",
        components: [
          {
            anchor: "A",
            name: "CheckboxWithLabel",
            styleClasses: [""],
            properties: {
              isReadOnly: false,
              isRequired: false,
              title: __("common.kokeilulupa"),
              type: "text",
              isChecked: isChecked
            }
          }
        ]
      }
    ]
  };
}
